import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'styled-components'
import withSiteContext from 'layers/content/v2/Hocs/withSiteContextLegacy'
import ProgramCard from './component.jsx'
import { isDigitalWellBeingProgram } from './helpers'

const ProgramCardWithTheme = withTheme(ProgramCard)
const ProgramCardWithSiteContext = withSiteContext(ProgramCardWithTheme)

const ProgramCardContainer = props => {
  if (isDigitalWellBeingProgram(props?.program)) {
    return <ProgramCardWithTheme {...props} />
  }

  return <ProgramCardWithSiteContext {...props} />
}

ProgramCardContainer.propTypes = {
  program: PropTypes.string,
}

export default ProgramCardContainer
